const translations = {
  "en": {
    "Connect portfolio": "Connect portfolio",
    "Maybe later": "Maybe later",
    "Snap a photo": "Snap a photo",
    "Upload a statement": "Upload a statement"
  },
  "zh-tw": {
    "Connect portfolio": "連接投資組合",
    "Maybe later": "暫不",
    "Snap a photo": "拍一張照片",
    "Upload a statement": "上傳一份對帳單"
  }
};

export default translations;
